import { render, staticRenderFns } from "./assets2.vue?vue&type=template&id=68c6697c&scoped=true&"
import script from "./assets2.vue?vue&type=script&lang=js&"
export * from "./assets2.vue?vue&type=script&lang=js&"
import style0 from "./assets2.vue?vue&type=style&index=0&id=68c6697c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c6697c",
  null
  
)

export default component.exports